import SectionHeading from "./SectionHeading";
import { tvPlatforms } from "@/mocks/installData";

export default function TvInstall() {
  const tv = tvPlatforms[0];

  return (
    <section id="tv" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="TV Install"
          title="TV 版安装包获取与安装说明"
          desc="智能电视与电视盒子通常无法直接访问浏览器下载，推荐用 U 盘把 TV 版安装包拷贝到设备后本地安装，操作更稳定。"
        />

        <div className="max-w-6xl mx-auto mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              <div className="bg-background-100 border border-background-200 rounded-lg p-4">
                <span className="text-xs text-foreground-500 font-label">适用系统</span>
                <p className="mt-1 text-sm font-semibold text-foreground-950">{tv.systemReq}</p>
              </div>
              <div className="bg-background-100 border border-background-200 rounded-lg p-4">
                <span className="text-xs text-foreground-500 font-label">安装包</span>
                <p className="mt-1 text-sm font-semibold text-foreground-950">{tv.badge}</p>
              </div>
              <div className="bg-background-100 border border-background-200 rounded-lg p-4">
                <span className="text-xs text-foreground-500 font-label">体积</span>
                <p className="mt-1 text-sm font-semibold text-foreground-950">{tv.packageSize}</p>
              </div>
            </div>

            <ol className="mt-6 flex flex-col">
              {tv.steps.map((step, index) => (
                <li key={step.id} className="flex gap-4 pb-6 last:pb-0 relative">
                  {index !== tv.steps.length - 1 && (
                    <span className="absolute left-4 top-9 bottom-0 w-px bg-background-300"></span>
                  )}
                  <div className="shrink-0 w-8 h-8 rounded-full bg-accent-500 text-background-50 flex items-center justify-center text-sm font-label z-10">
                    {index + 1}
                  </div>
                  <div className="pt-0.5">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950">
                      {step.title}
                    </h3>
                    <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                  </div>
                </li>
              ))}
            </ol>

            <div className="mt-6 flex items-start gap-3 bg-secondary-100 border border-secondary-200 rounded-lg p-4">
              <i className="ri-lightbulb-line text-secondary-700 text-xl shrink-0"></i>
              <p className="text-sm text-secondary-900 leading-relaxed">
                安装包文件名请保持原样，不要解压或改名；部分电视需在「设置 → 通用 → 未知来源」中提前放行，否则安装按钮会呈灰色不可点击。
              </p>
            </div>
          </div>

          <div className="relative rounded-xl overflow-hidden bg-background-200 h-[300px] md:h-[460px] lg:h-[540px]">
            <img
              src="https://readdy.ai/api/search-image?query=large%20flat%20screen%20smart%20television%20in%20a%20cozy%20dim%20living%20room%20showing%20a%20dark%20streaming%20interface%20with%20warm%20amber%20glow%2C%20minimal%20clean%20interior%20with%20soft%20ambient%20lighting%2C%20cinematic%20evening%20mood%2C%20high%20detail&width=1000&height=700&seq=starfilm-tv-2026&orientation=landscape"
              alt="星辰影视 TV 版在智能电视上的播放效果示意"
              className="absolute inset-0 w-full h-full object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}